module.exports = __webpack_public_path__ + "static/media/space.f93e190e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Home/Hero/space.jpg
// module id = 94
// module chunks = 0